import React from "react";
import ScrollToTop from "react-scroll-to-top";
import Preloader from  "../helper/Preloader";
import BreadcrumbImage from  "../components/BreadcrumbImage";
import WhyBecomeSeller from  "../components/WhyBecomeSeller";
import StepsSection from  "../components/StepsSection";
import ShippingOne from  "../components/ShippingOne";
 import BottomFooter from  "../components/BottomFooter";
import HeaderFooter from  "../componentsAmazon/HeaderFooter";
import FooterOne from  "../components/FooterOne";
import AmazonMarchandCenter from "../componentsAmazon/AmazonMarchandCenter";

const FooterMerchantCenter = () => {
  
  return ( 
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#FA6400' />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */} 
      <HeaderFooter/>
 

      {/* AmazonDropshipping */}
      <AmazonMarchandCenter/>
 
      {/* ShippingOne */}
 
      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default FooterMerchantCenter;
